import $ from 'jquery';
import debounce from '../util/debounce';

export function tabs(container) {
  tabsListener(container);
  accordion(container);
  tabsSpaceCheck(container);
  $(window).on(
    'resize',
    debounce(function() {
      tabsSpaceCheck(container);
    }, 200),
  );
}

export function destroyTabs(container) {
  $('ul.tabs > li', container).off();
  $('.accordion-toggle', container).off();
}

function tabsListener(container) {
  $('.tab-content-0', container).addClass('current');
  $('.tab-link-0', container).addClass('current');

  $('ul.tabs > li', container).click(function() {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs > li', container).removeClass('current');
    $('.tab-content', container).removeClass('current');
    $(this).addClass('current');
    $('.tab-content-' + tab_id, container).addClass('current');
  });
}
function accordion(container) {
  // mobile accordion for tabs content
  $('.accordion-toggle', container).click(function() {
    if (
      $(this)
        .next('div')
        .is(':visible')
    ) {
      $(this)
        .next('div')
        .slideUp('fast');
      $(this).removeClass('accordionExpanded');
    } else {
      $(this)
        .next('div')
        .slideDown('fast');
      $(this).addClass('accordionExpanded');
    }
  });
}
function tabsSpaceCheck(container) {
  var tabsWidth = 0;
  $('.tab-link').each(function() {
    tabsWidth += parseInt($(this).width(), 10);
  });
  // 10 is our padding buffer, if it's that close go for accordion
  var tabsWrapper = $('.productTabsWrapper', container).width() - 10;
  if (tabsWidth >= tabsWrapper) {
    $('.product-tabs', container).css({
      position: 'absolute',
      left: '-9999px',
      display: 'table',
    });
    $('.product-accordion', container).show();
  } else {
    $('.product-tabs', container).removeAttr('style');
    $('.product-accordion', container).hide();
  }
}
